const config = {
    api: {
        url: "https://api.shoesforeducation.org"
    },
    google: {
        clientId: "592260160711-bd7gsbvjq2j6jft0eifed38i4rplpn4g.apps.googleusercontent.com",
    },
    stripe: {
        key: "pk_live_51JelKwH8hQfkHNdNlHL90vwPSbngSo5U9psZxxCsYKBPb3peGIiE6O0sE3DeHA8LXiGOwswdd9LyYSSU5CCDeZVt00WQu4rFqW",
    }
}

export default config;